// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zimbra-item-mail{border-top:1px solid grey;min-height:60px}.item-inbox-after{content:\"\";position:absolute;bottom:0;left:1.6rem;width:calc(100% - 3.2rem);height:1px;background-color:#ebedf3}", ""]);
// Exports
module.exports = exports;
